import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { GCADALazyLoadingComponent } from './lazy-loading.component';


@NgModule({
    declarations: [
        GCADALazyLoadingComponent
    ],
    imports: [
        MatButtonModule
    ],
    entryComponents: [
        GCADALazyLoadingComponent
    ],
    exports:[
        GCADALazyLoadingComponent
    ]
})
export class GCADALazyLoadingModule {
}